import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=0bb4ccc2&scoped=true&"
import script from "./previewImage.js?vue&type=script&lang=js&"
export * from "./previewImage.js?vue&type=script&lang=js&"
import style0 from "./previewImage.scss?vue&type=style&index=0&id=0bb4ccc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb4ccc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
